export class Instrument {
  constructor(
    public stockId?: number,
    public regionId?: 1 | 2 | 3 | 4 | 5,
    public symbol?: string,
    public exchange?: string,
    public company?: string,
    public region?: string,
    public stockType?: StockType,
    public startDate?: string,
    public endDate?: string,
    public delisted?: boolean,
    public price?: number,
    public change?: number,
    public changePercent?: number,
    public hasOptions?: boolean
  ) {
  }

  public get nameAndExchange() {
    return this.symbol + (this.exchange ? (':' + this.exchange) : '');
  }
}

export class Future extends Instrument {
  constructor(
    public code?: string,
    public underlyingId?: number,
  ) {
    super();
  }

  public get nameAndExchange() {
    return this.symbol + (this.code ? (':' + this.code) : '');
  }
}

export type StockType =
  StockTypeEnum.INDEX |
  StockTypeEnum.STOCK |
  StockTypeEnum.FUND |
  StockTypeEnum.FX_INDEX;
export enum StockTypeEnum {
  FUND = 'F',
  STOCK = 'S',
  INDEX = 'I',
  FX_INDEX = 'X'
}
